import { CurrentHealthcareProviderInvoicePdfQuery } from '@dreryk/egabinet-invoice-frontend-api';

import { useCqrsExists } from '@dreryk/command-query-react-common';
import { Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { invoiceSharedTranslationKeys } from '../../translations';

type CurrentHealthcareProviderInvoicePdfRenderProps = {
   invoiceExists: boolean;
};

type CurrentHealthcareProviderInvoicePdfLoaderProps = {
   readonly children: (renderProps: CurrentHealthcareProviderInvoicePdfRenderProps) => JSX.Element;
   readonly referenceId: string;
};

export const CurrentHealthcareProviderInvoicePdfLoader = (
   props: CurrentHealthcareProviderInvoicePdfLoaderProps
): JSX.Element | null => {
   const {
      data: currentHealthcareProviderInvoicePdf,
      loading: currentHealthcareProviderInvoicePdfLoading,
      error: currentHealthcareProviderInvoicePdfError,
   } = useCqrsExists(() => {
      const query = new CurrentHealthcareProviderInvoicePdfQuery();

      query.referenceId = Slot.of(props.referenceId);

      return query;
   });

   if (currentHealthcareProviderInvoicePdfLoading) {
      return null;
   }

   if (currentHealthcareProviderInvoicePdfError) {
      return (
         <Message
            testId={'failedToFetchData'}
            label={invoiceSharedTranslationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      invoiceExists: currentHealthcareProviderInvoicePdf,
   });
};
